<template>
  <div class="grade_caifu" id="hydj">
    <topNav typeName vuePage="#hydj" title="我的活跃等级" back="1" closeweb="1"></topNav>
    <!-- 顶部用户信息的  进度条的组件 -->
    <gradecom
      :myriches="myriches"
      :probgcolor="probgcolor"
      :probgcolora="probgcolora"
      :prowidth="prowidth"
      :caifu="gradename"
      :expname="expname"
    />

    <!-- 分值构成 -->
    <div class="score_box">
      <p class="ptitle">分值构成</p>
      <div class="score_center flex-box">
        <div class="center_chart">
          <!-- 环状表 -->
          <ve-ring
            :data="chartData"
            :colors="appcolor"
            :tooltip-visible="false"
            :legend-visible="false"
            :settings="chartSettings"
          ></ve-ring>
        </div>
        <div class="center_r">
          <p class="center_r_t">
            等级：
            <i>Lv.{{myriches.thislevel}}</i>
          </p>
          <p class="center_r_b">活跃等级是用户在朱贝上的活跃度，魅力和消费能力的综合体现</p>
        </div>
      </div>
      <div class="score_bottom flex-box">
        <div class="div1">
          <p>活跃分值</p>
          <p>{{active_val}}</p>
        </div>
        <div class="div2">
          <p>消费分值</p>
          <p>{{cons_val}}</p>
        </div>
      </div>
    </div>
    <div class="show_bg"></div>
    <!-- 等级特权 -->
    <gradetequan :gradeLists="gradeArrlist" />

    <div class="btn_box relativeItem">
      <p class="btn absoluteItem" @click="uplivelygrade()">提升我的活跃等级</p>
    </div>
  </div>
</template>





<script>
import Gradecom from "./gradecaifucom";
import Gradetequan from "./gradetequan";
import topNav from "../index/top_nav";

export default {
  components: {
    Gradecom,
    Gradetequan,
    topNav
  },
  data() {
    this.chartSettings = {
      radius: [30, 40],
      hoverAnimation: false,
      labelLine: {
        show: false
      }
    };
    return {
      chartData: {
        columns: ["分值", "score"],
        rows: [
          { 分值: "", score: 0 }, // 财富分值
          { 分值: "", score: 0 } // 活跃分值
        ]
      },
      appcolor: ["#4a90ec", "#ff5a47"],
      probgcolor: "rgb(255, 92, 54)", // 当前进度条的颜色
      probgcolora: "rgba(255, 92, 54, .2)", // 进度条的背景色
      myriches: {},
      prowidth: "", // 进度条的宽度  百分比
      // 等级特权的数组
      gradeArrlist: [],
      gradename: "活跃等级",
      expname: "经验值",
      cons_val: 0,
      active_val: 0,
    };
  },
  methods: {
    uplivelygrade() {
      this.$router.push({ path: "/gradehuoyuets" });
    },
    getInfo() {
      let _this = this;
      let data = {
        type: 1
      };
      //如果链接上有userID就进行管理操作
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.userid = this.$route.query.uid;
      }
      _this.$jsonp(_this.$apis("grade_level"), data, res => {
        _this.myriches = res.body.data.data.list;
        _this.prowidth = res.body.data.data.list.bilie * 100;
        if (_this.prowidth < 0) {
          _this.prowidth = 0;
        }
        if (_this.prowidth > 100) {
          _this.prowidth = 100;
        }
        _this.chartData.rows[0].score = res.body.data.data.list.cons_val;
        _this.chartData.rows[1].score = res.body.data.data.list.active_val;
        _this.cons_val = _this.$tool.million(res.body.data.data.list.cons_val);
        _this.active_val = _this.$tool.million(
          res.body.data.data.list.active_val
        );
        _this.gradeArrlist = res.body.data.data.list.priviege;
      });
    }
  },
  mounted() {
    this.$tool.setTitle("我的活跃等级");
    this.getInfo();
  }
};
</script>





<style scoped lang="scss">
.grade_caifu {
  background-color: #fff;
  min-height: 100vh;
  width: 100%;
}
.my_grade {
  width: 5rem;
  height: 2rem;
  line-height: 2rem;
  font-weight: bold;
  border-radius: 1rem;
  background-color: #58bbd3;
  margin: 0 auto;
  color: #fff;
}

// 分值构成部分
.score_box {
  margin-bottom: 6px;
  background-color: #fff;
  .ptitle {
    color: #454545;
  }
  padding: 10px 20px;
  .score_center {
    margin: 20px 0;
    height: 100px;
    align-items: center;
    .center_chart {
      width: 35%;
    }
    .center_r {
      width: 65%;
      i {
        font-style: normal;
      }
      .center_r_t {
        color: #454545;
      }
      .center_r_b {
        margin-top: 10px;
        color: #c5c5c5;
        font-size: 0.8rem;
        line-height: 1.5;
      }
    }
  }
  .score_bottom {
    justify-content: space-around;
    .div1 p:nth-child(1),
    .div2 p:nth-child(1) {
      width: 60px;
      position: relative;
      color: #bababa;
      font-size: 0.7rem;
      text-align: right;
      margin: 0 auto;
    }
    .div1 p:nth-child(2),
    .div2 p:nth-child(2) {
      margin-top: 5px;
      color: #666;
      font-weight: bold;
      font-size: 1.6rem;
      text-align: center;
    }
    .div1 p:nth-child(1)::before {
      content: "";
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #ff5a47;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }
    .div2 p:nth-child(1)::before {
      content: "";
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #4a90ec;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }
  }
}

.show_bg {
  width: 100%;
  height: 6px;
  background-color: #f5f5f5;
}
// 等级特权
.center_box {
  width: 100%;
  padding: 20px 15px 5px;
  margin: 0 auto;
  background-color: #fff;
  p {
    color: #616161;
    font-size: 14px;
  }
  li {
    margin: 40px 0;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 50px;
      height: 20px;
    }
    div {
      margin-left: 20px;
      font-size: 15px;
      color: #333;
      font-weight: 600;
    }
  }
}
.btn_box {
  height: 120px;
  width: 100%;
  background-color: #fff;
}
.btn {
  background-color: #ff4da4;
  color: #fffeff;
  width: 200px;
  height: 50px;
  line-height: 50px;
  border-radius: 30px;
  text-align: center;
  font-size: 13px;
  margin: 0 auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>